import i18n from "i18n";
import styles from "./EmptyArcTags.module.scss";
import emptyTags from "assets/images/empty-tags.svg";

export const EmptyArcTags = () => {
  return (
    <div className={styles["empty-arc-tags"]}>
      <img src={emptyTags} alt={i18n.t("tag.reader")} />
      <p>{i18n.t("no.tags.regitered.pass.products")}</p>
    </div>
  );
};
